import { motion } from "motion/react";

export function HeroVideo() {
  return (
    <section className="px-4 pb-10 sm:px-6 md:pb-16">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="relative mx-auto max-w-5xl"
      >
        {/* The CDN-hosted light hero video (same asset as /wab), framed with a
            hairline + soft warm shadow on the off-white ground. */}
        <div
          className="relative overflow-hidden"
          style={{
            border: "1px solid var(--hair)",
            boxShadow: "0 24px 60px -28px rgba(11, 11, 12, 0.18)",
          }}
        >
          <video
            autoPlay
            loop
            muted
            playsInline
            className="block w-full"
            poster="https://static.wonda.sh/landing-media/heywonda/hero-poster.jpg"
            ref={(el) => {
              if (!el) return;
              el.setAttribute("muted", "");
              el.muted = true;
            }}
          >
            <source
              src="https://static.wonda.sh/landing-media/heywonda/hero.mp4"
              type="video/mp4"
            />
          </video>

          {/* Premium caption over the light hero video — the /wab display
              treatment (Fraunces italic), centered + large. A soft dark wash
              + text-shadow keep the white legible over the bright footage. */}
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0 z-[1]"
            style={{
              background:
                "linear-gradient(0deg, rgba(8,12,5,0.5) 0%, rgba(8,12,5,0.16) 42%, rgba(8,12,5,0.12) 68%, rgba(8,12,5,0.3) 100%)",
            }}
          />
          <div className="pointer-events-none absolute inset-0 z-[2] flex items-center justify-center px-6">
            <p
              className="text-center text-balance"
              style={{
                fontFamily: '"Fraunces", "EB Garamond", Georgia, serif',
                fontStyle: "italic",
                fontWeight: 400,
                letterSpacing: "-0.012em",
                lineHeight: 1.08,
                fontSize: "clamp(34px, 5.6vw, 64px)",
                color: "#ffffff",
                maxWidth: "16ch",
                textShadow:
                  "0 2px 40px rgba(8,12,5,0.72), 0 1px 5px rgba(8,12,5,0.5)",
              }}
            >
              Stop doing things manually. Safely delegate to Claude
            </p>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
